import { Switch, Route, withRouter } from 'react-router-dom'
import Tasks from './Tasks'
import CreateTask from './CreateTask'

const PipelinesRouter = ({ match }) => {
  const { path } = match

  return (
    <Switch>
      <Route path={`${ path }/tasks/:taskId`}><CreateTask /></Route>
      <Route path={`${ path }/tasks`} render={(props) => <Tasks {...props}/>}/>
    </Switch>
  )
}

export default withRouter(PipelinesRouter)

